import React from 'react';
import { Helmet } from '@okapi/helmet-react';

export const MetaHTML = () => (
	<Helmet>
		<html lang="ru" />
	</Helmet>
);
